import Sockette from 'sockette';

import EventEmitter, {
  READER_CONNECT_CHANGED,
  SDK_CONNECT_CHANGED,
  // SDK_CONNECT_DONE,
  // SDK_CONNECT_INTERRUPTED,
} from '@/tool/events';

import * as Events from './Events';
import { transformException } from './Exceptions';

export default class Scoket {
  socket = null;

  // 是否已经连接完成的标志
  hasConnected = false;

  // 是否已经注册完成的标志
  hasRegistered = false;

  // 是否已经进行连接失败提示的标志
  hasRemindError = false;

  // 发送命令时的结果处理handler
  handlers = [];

  // 发送注册命令时的结果处理handler
  registerHandler = null;

  // 上一次Reader的连接标志
  lastReaderStatus = false;

  // 是否允许重连的标志
  blockReconnect = false;

  onMessage = e => {
    const { data } = e;
    if (data.startsWith('@')) {
      // console.warn(data);
      // TODO: 有时SDK返回的发卡器连接状态并不准（明明没连接，却返回@NFCEncoder，连接或断开了也有时不会及时响应）

      // HM SDK 在刷新页面，registerSdk未调用/完成的情况下，拔出发卡器不会返回@Closed命令，严重bug
      // 先暂时处理一下，保证已注册成功后，再更新发卡器状态，这样带来的问题是，发卡器更新状态可能稍慢几秒

      // 当前发卡器的连接状态，true为连接，false为未连接
      // 除了NFCEncoder和BLEEncoder事件，还包括NFCKey和BLEKey（当钥匙放在发卡器上的时候）
      // 所以这里直接判断不是是不是断开事件，即包含了剩下的四种状态
      const currentReaderStatus = data != Events.READER_DISCONNECT;

      // 判断一下上次连接状态，避免重复发送事件
      if (this.lastReaderStatus != currentReaderStatus) {
        if (currentReaderStatus) {
          if (this.hasRegistered) {
            EventEmitter.emit(READER_CONNECT_CHANGED, true);
            this.lastReaderStatus = true;
          }
        } else {
          EventEmitter.emit(READER_CONNECT_CHANGED, false);
          this.lastReaderStatus = false;
        }
        // EventEmitter.emit(READER_CONNECT_CHANGED, data == Events.NFC_READER_CONNECT || data == Events.BLE_READER_CONNECT);
        // this.lastReaderStatus = data;
      }
    } else {
      console.log(data);
      if (this.registerHandler) {
        const [resolve, reject] = this.registerHandler;
        const response = JSON.parse(data);
        if (response.result) {
          resolve(response.result);
          this.hasRegistered = true;
        } else reject(transformException(response.data));
        this.registerHandler = null;
      } else if (this.handlers.length > 0) {
        const [resolve, reject] = this.handlers[0];
        try {
          const response = JSON.parse(data);
          if (response.result) {
            resolve(response.data);
          } else reject(transformException(response.data));
        } catch (err) {
          // TODO: 这里直接返回的e是json解析失败的错误是字符串：Unexpected token...需不需要进一步处理
          reject(err);
        }
        this.handlers.shift();
      }
    }
  };

  onOpen = () => {
    console.warn('xxxxxxxx socket opened xxxxxxxxxxx');
    this.hasConnected = true;
    this.hasRemindError = false;

    // 如果当前是阻止重连的模式，再手动改回允许重连
    if (this.blockReconnect) this.blockReconnect = false;

    EventEmitter.emit(SDK_CONNECT_CHANGED, true);
  };

  onClose = () => {
    console.warn('socket closed');
    this.hasConnected = false;
    this.hasRegistered = false;

    this.lastReaderStatus = false;

    if (!this.hasRemindError) {
      EventEmitter.emit(READER_CONNECT_CHANGED, false);
      EventEmitter.emit(SDK_CONNECT_CHANGED, false);
      this.hasRemindError = true;
    }
  };

  onOverload = () => {
    console.log('socket overload');
  };

  onReconnecting = () => {
    console.log('socket reconnecting');
  };

  onError = e => {
    console.log('socket error occured');
    if (this.blockReconnect) {
      // eslint-disable-next-line no-unused-vars
      e.target.onclose = ev => {
        console.log('manually stopped reconnecting');
      };
    }
  };

  connect(url) {
    // TODO: 如果在IE下连接的websocket主机是localhost，必须取消IE内容设置里面的内网取消相关勾选，才可以进行通讯，
    // 否则会报SCRIPT5022: SecurityError错误，加个try catch避免中断
    try {
      this.socket = new Sockette(url, {
        // maxAttempts : -1,
        timeout: 2000, // 2s超时时间
        onopen: this.onOpen,
        onclose: this.onClose,
        onreconnect: this.onReconnecting,
        onerror: this.onError,
        onmaximum: this.onOverload,
        onmessage: this.onMessage,
      });
    } catch (e) {
      console.warn(e);
    }
    // 每次请求链接时把错误的提示状态更新为false，防止重新登陆后无法弹出错误提示
    this.hasRemindError = false;
  }

  disconnect() {
    if (this.socket) {
      console.log('ready to disconnect');
      this.socket.close(1000);
    }
    // 再退出到登陆界面后，充值以下错误提醒状态;
    // this.hasRemindError = false;
  }

  stopReconnect() {
    // if (this.socket) {
    //     this.socket.close(1005);
    // }
    this.blockReconnect = true;
  }

  send(cmd, data) {
    const body = { cmd, data };
    return new Promise((resolve, reject) => {
      if (this.socket && this.hasConnected && this.hasRegistered) {
        this.handlers.push([resolve, reject, cmd]);
        this.socket.json(body);
      } else reject(transformException({ error: 'Socket is not connected' }));
    });
  }

  reigster(cmd, data) {
    const body = { cmd, data };
    console.log(body);
    return new Promise((resolve, reject) => {
      if (this.socket && this.hasConnected) {
        console.log('send register cmd');
        this.registerHandler = [resolve, reject];
        this.socket.json(body);
      } else reject(transformException({ error: 'Socket is not connected' }));
    });
  }
}
